import { Component, Inject, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { PagerService } from '../../services/shared/pager.service';
import { Faq } from '../../models/faq/faq-model';
import { FaqCategory } from '../../models/faq/faq-category-model';
import { FaqService } from '../../services/faq/faq.service';
import { FaqCategoryService } from '../../services/faq/faq-category.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-faq-list',
    templateUrl: './faq-list.component.html',
    styleUrls: ['./faq-list.component.scss']
})
/** faq-list component*/
export class FaqListComponent {
  public FaqList: Faq[];
  public FaqCategoryList: FaqCategory[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public selectedCategory: any;
  searchKeyword: string;
  faqCategoryID: number;
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
    /** faq-list ctor */
  constructor(private readonly FaqService: FaqService, private readonly FaqCategoryService: FaqCategoryService, private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("faq").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;

          if (list.length > 0) {
          this.getFaqs();
          this.getCategories();
          this.GetRowsPerPageList();
          this.toastr.setRootViewContainerRef(vcr);
          this.getFaqCategories();
            this.faqCategoryID = 0;
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  deleteFaq(id) {
    if (confirm("Are you sure to delete this faq ?")) {
      this.FaqService.deleteFaq(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('FAQ has been deleted.', 'Success');
            setTimeout(() => {
              this.getFaqs();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Please try again', 'Success');
          }
        }
      )
    }
  }
  getFaqCategories() {
    this.FaqCategoryService.getFaqCategories().subscribe(
      data => {
        this.FaqCategoryList = data
      }
    )
  } 
  getFaqs() {
    this.FaqService.getFaqs().subscribe(
      data => {
        this.FaqList = data;
        this.filteredItems = data;
      }
    )
  }
  // Populate the row per page list
  getCategories() {
    this.FaqCategoryService.getFaqCategories().subscribe(
      data => {
        this.FaqCategoryList = data;
      }
    );

  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  OnFilterChange() {
    this.filteredItems = this.FaqList;

    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }
    if (this.faqCategoryID > 0) {
      this.filteredItems = this.filteredItems.filter(s => s.faqCategoryID == this.faqCategoryID);

    }
  }
  // Select Grid Category
  ChangeCategory(catid: number) {
    if (catid != 0) {
      this.filteredItems = this.filteredItems.filter(item => item.faqCategoryID == catid);

    } else {
      this.filteredItems = this.FaqList;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/faq-components/faq-list/faq-list.component.ts